import { render, staticRenderFns } from "./SummaryData.vue?vue&type=template&id=01443496&scoped=true"
import script from "./SummaryData.vue?vue&type=script&lang=js"
export * from "./SummaryData.vue?vue&type=script&lang=js"
import style0 from "./SummaryData.vue?vue&type=style&index=0&id=01443496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01443496",
  null
  
)

export default component.exports